const EXPERIMENTS = {
  QUANTUM_LEAP_ENABLED: 'Trmt_rewards_quantumleap_jan2024',
  WEB_SEARCH_ENABLED: 'Trmt_Shopping_web_search_revamp',
  WEB_ADS_ENABLED: 'Trmt_PayPal_Web_Ads_Shopping_Ramp'
}

export default EXPERIMENTS
